export const getOperationType = (operationType: number) => {
  const types = {
    0: 'начисление компенсации',
    1: 'отмена начисления компенсации',
    2: 'вывод по заявлению на р / с',
    3: 'вывод на л / с',
    4: 'отмена вывода по заявлению на р / с',
  }
  return types[operationType]
}
